export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14005.c5cf7d3f.jpg";